// Web Share with a clipboard fallback. Shared by LinkCard's overflow menu and
// the quick-actions sheet; the test imports THIS function (lessons.md: a test
// that re-implements the branch it is testing cannot fail when the source
// regresses). i18n-free: LinkCard is in the embed closure.

/**
 * @param {{ url?: string, title?: string }} item
 * @returns {Promise<'shared'|'copied'|'aborted'|'unavailable'|'noop'>}
 */
export async function shareLink(item) {
  if (!item || !item.url) return 'noop'
  if (typeof navigator !== 'undefined' && navigator.share) {
    try {
      await navigator.share({ title: item.title || '', url: item.url })
      return 'shared'
    } catch (e) {
      // The user closed the share sheet — not a failure, and not a reason to
      // silently overwrite their clipboard.
      if (e && e.name === 'AbortError') return 'aborted'
    }
  }
  // Both Web Share and the Clipboard API are gated on a secure context, so the
  // fallback is exactly where they are missing (the PWA served over plain http
  // on a LAN IP while testing on a phone). Dereferencing them there threw a
  // TypeError that reached the sheet's awaiting handler as an unhandled
  // rejection, with the sheet already closed and no feedback to the user.
  if (typeof navigator === 'undefined' || !navigator.clipboard) return 'unavailable'
  try {
    await navigator.clipboard.writeText(item.url)
    return 'copied'
  } catch {
    // Permission denied, or the document lost focus mid-write.
    return 'unavailable'
  }
}
